import { EditorViewState } from 'owa-editor';
import { IEditor } from 'roosterjs-editor-types';
import { CommandProps } from '@fluidx/office-fluid-types';
import { LoadedInfo } from '@ms/office-web-host';

type FluidContainerConfigType = 'editor' | 'div';

export interface FluidContainerConfig {
    configType: FluidContainerConfigType;
    containerId?: string;
    controlNode?: React.ReactElement<{}>;
    customMenuItems?: CommandProps[];
    onMount?: (loadedInfo: LoadedInfo) => void;
}

export interface FluidContainerConfigForEditor extends FluidContainerConfig {
    configType: 'editor';
    editorViewState: EditorViewState;
    editor?: IEditor;
}

export interface FluidContainerConfigForDiv extends FluidContainerConfig {
    configType: 'div';
    containerDiv: HTMLDivElement;
}

export function isFluidContainerConfigForDiv(
    config: FluidContainerConfig
): config is FluidContainerConfigForDiv {
    return config.configType === 'div';
}

export function isFluidContainerConfigForEditor(
    config: FluidContainerConfig
): config is FluidContainerConfigForEditor {
    return config.configType === 'editor';
}
